export const DownloadDataAsJsonFile = (data: any, filename: string) => {
  const link = document.createElement('a');
  link.download = `${filename}.json`;
  link.href = URL.createObjectURL(new Blob([JSON.stringify(data, null, 1)], 
      {type: "application/json"}));
  link.click();
}
